/**
 * Load all images from a project folder
 * @param projectId - The project folder name (e.g., 'pms', 'moya', 'neo')
 * @returns Array of image paths
 */
export const getProjectImages = (projectId: string): string[] => {
  const images: string[] = []
  
  try {
    // Dynamic import of images from the project folder
    const imageContext = import.meta.glob('/src/assets/images/projects/**/*.(jpg|jpeg|png|webp|gif)', {
      eager: true,
      query: '?url',
      import: 'default'
    })
    
    // Filter images for the specific project folder
    Object.entries(imageContext).forEach(([path, url]) => {
      if (path.includes(`/projects/${projectId}/`)) {
        images.push(url as string)
      }
    })
    
    // Sort images by filename to ensure consistent order
    images.sort()
  } catch (error) {
    console.error(`Error loading images for project ${projectId}:`, error)
  }
  
  return images
}

/**
 * Get a random image from a project folder
 * @param projectId - The project folder name
 * @returns A random image path or empty string if no images found
 */
export const getRandomProjectImage = (projectId: string): string => {
  const images = getProjectImages(projectId)
  if (images.length === 0) return ''
  
  const randomIndex = Math.floor(Math.random() * images.length)
  return images[randomIndex]
}
